//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manageRange from '@/components/form-common/select-manageRange';
export default {
  name: 'FormBox',
  components: {
    manageRange: manageRange
  },
  props: ['activeName'],
  data: function data() {
    return {
      pickerOptions: this.$pickerOptionsTimeEle,
      fromStatus: [{
        text: this.$t('toptable.all'),
        val: ''
      }, {
        text: this.$t('customer.audit'),
        val: 0
      }, {
        text: this.$t('customer.passed'),
        val: 1
      }, {
        text: this.$t('customer.fail'),
        val: 2
      }],
      paymentTimeVal: [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')],
      tableFrom: {
        time_field: 'date',
        type: '',
        status: '',
        name: '',
        time: this.$moment().startOf('months').format('YYYY/MM/DD') + '-' + this.$moment().endOf('months').format('YYYY/MM/DD'),
        salesman_name: '',
        scope_frame: 'all'
      },
      sexOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '合同回款',
        value: 0
      }, {
        label: '合同续费',
        value: 1
      }, {
        label: '合同支出',
        value: 2
      }]
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.sexOptions = [{
        label: this.$t('finance.all'),
        value: 2
      }, {
        label: this.$t('customer.Contractpayment'),
        value: 1
      }, {
        label: this.$t('customer.contractrenewal'),
        value: 0
      }];
      this.fromStatus = [{
        text: this.$t('toptable.all'),
        val: ''
      }, {
        text: this.$t('customer.audit'),
        val: 0
      }, {
        text: this.$t('customer.passed'),
        val: 1
      }, {
        text: this.$t('customer.fail'),
        val: 2
      }];
    },
    changeStatus: function changeStatus() {
      this.confirmData();
    },
    // 确认
    handleConfirm: function handleConfirm() {
      this.confirmData();
    },
    handType: function handType(e) {
      if (e === '') {
        this.tableFrom.type = '';
      }
      this.confirmData();
    },
    // 选择成员完成回调
    changeMastart: function changeMastart(data) {
      this.tableFrom.scope_frame = data;
      this.confirmData();
    },
    establishTime: function establishTime(e) {
      if (e == null) {
        this.tableFrom.time = '';
        this.confirmData();
      } else {
        this.establishTimeVal = e;
        this.tableFrom.time = this.establishTimeVal[0] + '-' + this.establishTimeVal[1];
        this.confirmData();
      }
    },
    // 类型
    handStatus: function handStatus(e) {
      this.tableFrom.status = e;
    },
    reset: function reset() {
      this.tableFrom = {
        time: this.$moment().startOf('months').format('YYYY/MM/DD') + '-' + this.$moment().endOf('months').format('YYYY/MM/DD'),
        type: '',
        status: '',
        search: '',
        select: 2,
        time_field: 'date',
        scope_frame: 'all'
      };
      this.$refs.manageRange.frame_id = 'all';
      this.paymentTimeVal = [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')];
      this.confirmData();
    },
    confirmData: function confirmData() {
      this.$emit('confirmData', this.tableFrom);
    }
  }
};